// Generated by replace-version.mjs before every serve/build — do not edit (gitignored).
import { environment } from './environment';

export const BUILD_TIME = '2026.10.30 12:28:36';

const envSuffix = environment.production ? '' : ` ${environment.envName}`;

/** Full version string: release + build time + env name (env hidden on production). */
export const APP_VERSION = `${environment.releaseVersion} ${BUILD_TIME}${envSuffix}`;
